import { render, staticRenderFns } from "./skillsDiagram.vue?vue&type=template&id=81e36080&scoped=true"
import script from "./skillsDiagram.vue?vue&type=script&lang=js"
export * from "./skillsDiagram.vue?vue&type=script&lang=js"
import style0 from "./skillsDiagram.vue?vue&type=style&index=0&id=81e36080&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e36080",
  null
  
)

export default component.exports